import { ulid } from 'ulid';
import type { VehicleViewModel } from '@/graphql/generated';

type VehicleCloneInput = Pick<VehicleViewModel,
  | 'plateNumber'
  | 'make'
  | 'model'
  | 'color'
  | 'isActive'
  | 'vehicleTypeId'  // Lookup - preserved
  | 'customerId'     // Foreign key - preserved (optional, the vehicle belongs to same customer)
>;

/**
 * Clone a Vehicle entity
 * 
 * - vehicleId: NEW (regenerated)
 * - vehicleTypeId: PRESERVED (lookup reference)
 * - customerId: PRESERVED (foreign key - optional, the vehicle belongs to same customer)
 * - plateNumber: User should update this (plates are unique)
 * - All other fields: COPIED as-is
 */
export function cloneVehicle(source: VehicleCloneInput): VehicleCloneInput & { vehicleId: string } {
  return {
    // New entity ID
    vehicleId: ulid(),
    
    // Preserve lookup references
    vehicleTypeId: source.vehicleTypeId,
    
    // Preserve foreign keys
    customerId: source.customerId,
    
    // Copy vehicle details (user should update plateNumber as it must be unique)
    plateNumber: source.plateNumber,
    make: source.make,
    model: source.model,
    color: source.color,
    isActive: source.isActive,
  };
}

export type ClonedVehicle = ReturnType<typeof cloneVehicle>;
